import React from 'react';
import S from '../../styled';
import NetworkButton from '../NetworkButton';
import Module from '../Module';
import {CaretDownFill as CaretDownFillIcon} from "@styled-icons/bootstrap/CaretDownFill";
import styled from "styled-components";

const AccountSwitcherStyled = styled(S.Flex)`
    position: absolute;
    z-index: 1;
    justify-content: space-around;
    align-items: center;
    pointer-events: none;
    width: 100%;
`;

const LogoImageStyled = styled(S.Image)`
    width: 26px;
    height: 26px;
    border-radius: 100%;
`;

const AccountSwitcher = ({logo_url, accountName}) => {
    return (
        <AccountSwitcherStyled>
            {
                !!(logo_url) && (
                    <LogoImageStyled
                        src={logo_url}
                        alt={`Portal logo`}
                    />
                )
            }
            <S.Text as="span" style={{visibility: 'hidden'}}>{accountName}</S.Text>
            <CaretDownFillIcon width={'16px'} height={'16px'} />
        </AccountSwitcherStyled>
    );
}

export default AccountSwitcher;
